module.exports = __webpack_public_path__ + "static/the-pragmatic-programmer-7469fb16b656869ab5c59ab637d98f44.jpg";